export const convertAmountToApiFormat = (amount: string) => Number(amount.replaceAll(',', ''));
